import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { patchAttendInvitation } from "../../Store/Action";
import "../../index.css";
import { Link } from "react-router-dom";
import { XCircle, X } from "lucide-react";
import { useFetchRun } from "../../Hooks/useFetch";
import ModalInvitation from "./ModalInvitation";
import ModalAttended from "./ModalAttend.tsx";
import ModalCancel from "./ModalCancel.tsx";
import { getWithExpiry } from "@/utils/token";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import CardInvitation from "@/Components/MyPage/CardInvitation";
import ModalPackageForm from "@/Components/MyPage/ModalPackageForm";
// gunakan locale Korea
dayjs.locale("ko");

const S3_URL = import.meta.env.VITE_S3_URL;

function ListInvitation({ dataInvitation, setActiveTab }) {
  const dispatch = useDispatch();
  const [reservationData, setReservationData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showModalPackage, setShowModalPackage] = useState(false);
  const [showModalAttended, setShowModalAttended] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState({
    id: null,
    title: "",
    review_start_date: "",
    review_end_date: "",
  });

  const [cancelReason, setCancelReason] = useState("");

  const [formAttend, setAttendData] = useState({
    subscription_id: null,
    user_id: 0,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dataInvitation]);

  useEffect(() => {
    if (dataInvitation.length > 0) {
      dataInvitation.forEach((data) => {
        if(data.campaigns){
          data.campaigns.forEach((c) => {
            fetchDataReservation(c.campaign_id);
          })
        }
        fetchDataReservation(data.campaign_id);
      });
    }
  }, [dataInvitation]);

  const handleOpenModal = (campaign) => {
    setSelectedCampaign(campaign);
    setShowModal(true);

    setAttendData((prev) => ({
      ...prev,
      subscription_id: campaign.id,
    }));
  };

  const handleOpenModalPackage = (campaign) => {
    setSelectedCampaign(campaign);
    setShowModalPackage(true);
  };

  const handleOpenModalAttended = (campaign) => {
    setSelectedCampaign(campaign);
    setShowModalAttended(true);

    setAttendData((prev) => ({
      ...prev,
      subscription_id: campaign.id,
    }));
  };

  const handleUseInvitation = async () => {
    const isConfirmed = window.confirm(
      "초대권을 사용하시겠습니까? 업체에서 확인을 눌러주세요 :)"
    );

    if (!isConfirmed) {
      return;
    }

    if (!formAttend.subscription_id) {
      console.error("❌ Subscription ID tidak ditemukan!");
      return;
    }

    try {
      await dispatch(patchAttendInvitation(formAttend));
      setShowModal(false);
      setActiveTab("review");
    } catch (error) {
      console.error("Gagal menggunakan undangan:", error);
    }
  };
  const handleDownloadPdf = async (pdfPath) => {
    if (!pdfPath) {
      alert("PDF 파일이 없습니다");
      return;
    }

    const fileName = pdfPath.split("/").pop();

    const downloadLink = document.createElement("a");
    downloadLink.href = `${S3_URL}${encodeURI(pdfPath)}`;
    downloadLink.download = decodeURIComponent(fileName);
    downloadLink.target = "_blank";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handleOpenCancelModal = (campaign) => {
    setSelectedCampaign(campaign);
    setShowCancelModal(true);
  };

  const reqCancel = useFetchRun({
    url: `${import.meta.env.VITE_API_URL}/user/subscription/request-cancel`,
    method: "POST",
  });

  const handleCancelSubmit = async () => {
    if (!cancelReason.trim()) {
      alert("취소 사유를 입력해주세요.");
      return;
    }

    const isConfirmed = window.confirm("정말로 취소요청 하시겠습니까?");

    if (!isConfirmed) {
      return;
    }

    try {
      setShowCancelModal(false);
      setCancelReason("");
      const rest = await reqCancel.executeFetch({
        body: {
          subscription_id: selectedCampaign.id,
          reason: cancelReason,
        },
      });
      if (rest.meta.code == 200) {
        alert("취소요청이 완료되었습니다.");
      } else {
        alert("취소요청에 실패했습니다. 관리자에게 직접 문의주세요.");
      }
    } catch (error) {
      console.error("취소 실패:", error);
    }
  };

  const fetchDataReservation = async (campaign_id) => {
    if(!campaign_id) return;
    try {
      const token = getWithExpiry("token");
      const response = await fetch(
        `${
          import.meta.env.VITE_API_URL
        }/user/reservation/list?campaign_id=${campaign_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      const json = await response.json();

      if (json.meta.code === 200) {
        setReservationData((prev) => ({
          ...prev,
          [campaign_id]: json.data, // Simpan data per campaign_id
        }));
      } else {
        throw new Error(
          json.meta?.message || "Failed to fetch reservation data"
        );
      }
    } catch (error) {
      console.error("Failed to fetch calendar data:", error);
    }
  };

  return (
    <div className="flex mt-5 pb-10">
      <div className="gap-6 w-full">
        {dataInvitation.length > 0 ? (
          dataInvitation.map((item, index) => {
            const data = item.campaigns || item;

            // Famtour campaigns grouping
            if(Array.isArray(data) && data.length > 0){
              const enableCloseBtn = data.length === data[0].total_famtour_campaigns;

              return <div className="border border-1 border-[#C9C9C9] rounded-md">
                <div className="flex justify-between mx-3 mt-2">
                  <a href={`/detailFamtour/${data[0].fam_tour_id}`} className="font-bold text-[12px] text-[#46B6D0]">{data?.[0].fam_tour_title}</a>
                  <div className="w-1/12 relative flex flex-col items-end justify-start">
                    {
                      enableCloseBtn && <button
                        className="flex items-center gap-2 text-[9px] bg-[#fe7070] rounded-full shadow-sm px-2 border transition-colors text-white font-medium"
                        onClick={() => handleOpenCancelModal?.({id: item.id, is_famtour: true})}
                      >
                        <XCircle width={12} />
                        <div className="flex justify-between px-1">
                          <div>취</div>
                          <div>소</div>
                        </div>
                      </button>
                    }

                  </div>
                </div>
                {
                  data.map((famtour, i) => {
                    const rewardText = item?.reward?.replace(/<[^>]*>?/g, "")?.replace(/&nbsp;/g, " ");

                    return <CardInvitation
                      key={i}
                      item={famtour}
                      handleOpenModalAttended={handleOpenModalAttended}
                      handleOpenModalPackage={handleOpenModalPackage}
                      handleDownloadPdf={handleDownloadPdf}
                      handleOpenModal={handleOpenModal}
                      rewardText={rewardText}
                      reservationData={reservationData}
                      withCancel={false}
                    />
                  })
                }
              </div>
            }
            const rewardText = item.reward
              .replace(/<[^>]*>?/g, "")
              .replace(/&nbsp;/g, " ");
            return (
              <CardInvitation
                key={index}
                item={item}
                handleOpenModalAttended={handleOpenModalAttended}
                handleOpenModalPackage={handleOpenModalPackage}
                handleDownloadPdf={handleDownloadPdf}
                handleOpenModal={handleOpenModal}
                handleOpenCancelModal={handleOpenCancelModal}
                rewardText={rewardText}
                reservationData={reservationData}
                withCancel={true}
              />
            );
          })
        ) : (
          <div className="text-[12px] text-center text-[#999999] items-center justify-center py-10">
            <p className="">신청한 캠페인이 없습니다.</p>
            <p className="mt-1">다양한 캠페인에 신청해보세요:)</p>
            <div>
              <Link to={"/"}>
                <button className="border text-[12px] bg-[#E8EAF9] mt-3 text-[#0F1E6C] rounded-full px-3 py-2">
                  <p>캠페인 신청하러가기</p>
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>

      {/* {showModal && selectedCampaign && (
        <div className="fixed inset-0 flex items-center justify-center text-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md relative">
            <X
              className="absolute right-4 top-4 w-6 h-6 text-gray-800 cursor-pointer"
              onClick={() => setShowModal(false)}
            />

            <h2 className="text-xl font-bold mb-6 border-b pb-6 mt-4">
              [ 초대권 ]
            </h2>
            <p className="text-gray-700 mb-2 font-extrabold">
              {selectedCampaign ? selectedCampaign.nick_name : null}{" "}
              초대권입니다.
            </p>
            <p className="text-gray-500 mb-2">
              사용일자{" "}
              {selectedCampaign ? selectedCampaign.review_start_date : null} ~{" "}
              {selectedCampaign ? selectedCampaign.review_end_date : null}
            </p>

            <button
              type="button"
              className="px-4 py-3 w-full text-white bg-[#384D92] rounded-full font-semibold mt-5"
              onClick={handleUseInvitation}
            >
              초대권 사용
            </button>
          </div>
        </div>
      )} */}

      <ModalPackageForm showModal={showModalPackage} setShowModal={setShowModalPackage} campaign={selectedCampaign}/>
      <ModalInvitation
        showModal={showModal}
        setShowModal={setShowModal}
        selectedCampaign={selectedCampaign}
        handleUseInvitation={handleUseInvitation}
      />
      <ModalAttended
        showModal={showModalAttended}
        setShowModal={setShowModalAttended}
        selectedCampaign={selectedCampaign}
        handleUseInvitation={handleUseInvitation}
      />
      {showCancelModal && selectedCampaign && (
        <div className="fixed inset-0 flex items-center justify-center text-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg w-[90%] max-w-md relative">
            <X
              className="absolute right-4 top-4 w-6 h-6 text-gray-800 cursor-pointer"
              onClick={() => setShowCancelModal(false)}
            />

            <ModalCancel
              selectedCampaign={selectedCampaign}
              cancelReason={cancelReason}
              setCancelReason={setCancelReason}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ListInvitation;
